import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';

@Component({
    selector: 'app-copydataset-dialog',
    templateUrl: './copydataset-dialog.component.html',
    styleUrls: ['./copydataset-dialog.component.scss'],
    standalone: false
})
export class CopydatasetDialogComponent implements OnInit {
  buttonColor = ""

  ngOnInit(): void {
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
    this.validations_form = this.fb.group({
      datasetName :'',
      copydataset: ''
    });
  }

  // constructor(
  //   public dialogRef: MatDialogRef<CopydatasetDialogComponent>, // For closing the dialog
  //   @Inject(MAT_DIALOG_DATA) public data: any // Inject data from parent
  // ) {
  //   // Assign the passed data to component variables
  //   this.datasetName = data.datasetName; // Get dataset name from parent data
  //   this.otherData = data.otherData; // Get other data from parent (optional)
  // }


  form: FormGroup;
  data;
  validation_messages = {
    datasetName: [  
      { type: 'required', message: 'Dataset name is required.' },
      { type: 'pattern', message: 'Dataset name cannot be empty or contain only whitespace.' }
    ]
  };
  validations_form: UntypedFormGroup;

  constructor(private fb: FormBuilder,
    public dialogRef: MatDialogRef<CopydatasetDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public matdata: any,
    private localStorageSettings: LocalStorageSettingsService
  ) {
    this.form = this.fb.group({
      datasetName: ''
    });
    this.data = matdata.data
  }

  // Getter for easy access to the form control in HTML
  get datasetName() {
    return this.form.get('datasetName');
  }

  

  onCancel() {
    this.form.reset();
    this.validations_form.reset();
    this.dialogRef.close(); // Close the dialog
  
  }

  // onCopy() {
  //   if (confirm("Are you sure you want to copy the dataset?")) {
  //     const datasetNameValue = this.form.get('datasetName')?.value;
  //     this.data.node.data.datasetname = datasetNameValue;
  //     console.log(this.data)
  //     if (this.data.copyDataset instanceof Function) {
  //       const params = {
        

  //             rowData : this.data.node.data
  //         }
  //         this.data.CopyDataset(params)

  //     }
  //     this.onCancel();
  //   } 
  // }
  
  onCopy() {
    if (confirm("Are you sure you want to copy the dataset?")) {
      const datasetNameValue = this.form.get('datasetName')?.value;
      this.data.node.data.datasetname = datasetNameValue;
      console.log(this.data)
      if (this.data.copyDataset instanceof Function) {
        const params = {




          rowData: this.data.node.data
        }
        this.data.copyDataset(params)
        // 
      }
      this.onCancel();
    }
  }

  formValidation() {
    this.validations_form = new UntypedFormGroup({
      copydataset:new UntypedFormControl('',[Validators.required]),
      datasetName: new FormControl('', [Validators.required]),
    });
  }


}
